<!-- Main Dashboard Container -->
<div class="row">
  <div class="col-xl-12">
    <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
      <!-- Admin Dashboard (userType == 1) -->
      @if(userType==1) {
      <div class="row">
        <!-- Total Categories Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/category" style="cursor: pointer;">
            <h6 class="mb-4">Total Categories</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-layers f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalCategories}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Companies Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/company" style="cursor: pointer;">
            <h6 class="mb-4">Total Companies</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-briefcase f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalCompanies}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Distributor Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/wholesalers" style="cursor: pointer;">
            <h6 class="mb-4">Total Distributor</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="bi bi-truck f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalDistributors}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Issued To Customer Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/customers/samples/report" style="cursor: pointer;">
            <h6 class="mb-4">Total Issued To Customer</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-share f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalIssuedToCustomer}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Customers Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/customers" style="cursor: pointer;">
            <h6 class="mb-4">Total Customers</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-users f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalCustomers}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Today Customers Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/customers" style="cursor: pointer;">
            <h6 class="mb-4">Today Customers</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-user-plus f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.todayCustomers}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Recent Distributors Table -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <app-card cardTitle="Recent Users" cardClass="Recent-Users table-card" blockClass="p-0">
            <div class="table-responsive">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Recent Distributors</h5>
                  <button class="btn btn-sm btn-primary" routerLink="/distributors/all">View All</button>
                </div>

                <div class="table-responsive">
                  <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="recentDistributorsDataSource" class="table-bordered compact-table">

                      <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                        <td mat-cell *matCellDef="let row; let index = index">{{index+1}}</td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">{{element?.name}}</td>
                      </ng-container>

                      <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>Email</th>
                        <td mat-cell *matCellDef="let element">{{element?.email}}</td>
                      </ng-container>

                      <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef>Phone</th>
                        <td mat-cell *matCellDef="let element">{{element?.phone}}</td>
                      </ng-container>

                      <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef>City</th>
                        <td mat-cell *matCellDef="let element">{{element?.city}}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="recentDistributorsDisplayedColumns" class="t_head"></tr>
                      <tr mat-row *matRowDef="let row; columns: recentDistributorsDisplayedColumns;"></tr>
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="recentDistributorsDisplayedColumns.length">
                          No data available
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Recent Samples Table -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <app-card cardTitle="Recent Users" cardClass="Recent-Users table-card" blockClass="p-0">
            <div class="table-responsive">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Recent Samples</h5>
                  <button class="btn btn-sm btn-primary" routerLink="/sample">View All</button>
                </div>

                <div class="table-responsive">
                  <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="recentSamplesDataSource" class="table-bordered compact-table">

                      <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                        <td mat-cell *matCellDef="let row; let index = index">{{index+1}}</td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">{{element?.name}}</td>
                      </ng-container>

                      <ng-container matColumnDef="barcode">
                        <th mat-header-cell *matHeaderCellDef>Bar Code</th>
                        <td mat-cell *matCellDef="let element">{{element?.sampleCode}}</td>
                      </ng-container>

                      <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef>Total</th>
                        <td mat-cell *matCellDef="let element">{{element?.totalItems}}</td>
                      </ng-container>

                      <ng-container matColumnDef="category">
                        <th mat-header-cell *matHeaderCellDef>Category</th>
                        <td mat-cell *matCellDef="let element">{{element?.categoryId?.name || "NA"}}</td>
                      </ng-container>

                      <ng-container matColumnDef="company">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let element">{{element?.companyId?.name || "NA"}}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="recentSamplesDisplayedColumns" class="t_head"></tr>
                      <tr mat-row *matRowDef="let row; columns: recentSamplesDisplayedColumns;"></tr>
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="recentSamplesDisplayedColumns.length">
                          No data available
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
        </div>
      </div>
      }

      <!-- Secondary Admin Dashboard (userType == 2) -->
      @else if(userType==2) {
      <div class="row">

        <!-- Total Categories Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/category" style="cursor: pointer;">
            <h6 class="mb-4">Total Categories</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-layers f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalCategories}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Companies Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/company" style="cursor: pointer;">
            <h6 class="mb-4">Total Companies</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-briefcase f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalCompanies}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Distributors Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/distributors/all" style="cursor: pointer;">
            <h6 class="mb-4">Total Distributors</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="bi bi-truck f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalDistributors}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Issued to Customers Today Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/customers/samples/report" [queryParams]="{ isTodayCust: true }" style="cursor: pointer;">
            <h6 class="mb-4">Issued to Customers Today</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-share f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalIssuedToCustomer}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Customers Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/customers" style="cursor: pointer;">
            <h6 class="mb-4">Total Customers</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-users f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.totalCustomers}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Today Registered Customers Card -->
        <div class="col-md-6 col-xl-4">
          <app-card [hidHeader]="true" routerLink="/customers" [queryParams]="{ isTodayCust: true }" style="cursor: pointer;">
            <h6 class="mb-4">Today Registered Customers</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-user-plus f-30 m-r-10" style="color: #003E53;"></i>
                  {{dashboardData?.todayCustomers}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Recent Distributors Table -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <app-card cardTitle="Recent Users" cardClass="Recent-Users table-card" blockClass="p-0">
            <div class="table-responsive">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Recent Distributors</h5>
                  <button class="btn btn-sm btn-primary" routerLink="/distributors/all">View All</button>
                </div>

                <div class="table-responsive">
                  <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="recentDistributorsDataSource" class="table-bordered compact-table">

                      <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                        <td mat-cell *matCellDef="let row; let index = index">{{index+1}}</td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">{{element?.name}}</td>
                      </ng-container>

                      <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>Email</th>
                        <td mat-cell *matCellDef="let element">{{element?.email}}</td>
                      </ng-container>

                      <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef>Phone</th>
                        <td mat-cell *matCellDef="let element">{{element?.phone}}</td>
                      </ng-container>

                      <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef>City</th>
                        <td mat-cell *matCellDef="let element">{{element?.city}}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="recentDistributorsDisplayedColumns" class="t_head"></tr>
                      <tr mat-row *matRowDef="let row; columns: recentDistributorsDisplayedColumns;"></tr>
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="recentDistributorsDisplayedColumns.length">
                          No data available
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Recent Samples Table -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <app-card cardTitle="Recent Users" cardClass="Recent-Users table-card" blockClass="p-0">
            <div class="table-responsive">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Recent Samples</h5>
                  <button class="btn btn-sm btn-primary" routerLink="/sample">View All</button>
                </div>

                <div class="table-responsive">
                  <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="recentSamplesDataSource" class="table-bordered compact-table">

                      <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                        <td mat-cell *matCellDef="let row; let index = index">{{index+1}}</td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">{{element.name}}</td>
                      </ng-container>

                      <ng-container matColumnDef="barcode">
                        <th mat-header-cell *matHeaderCellDef>Bar Code</th>
                        <td mat-cell *matCellDef="let element">{{element?.sampleCode}}</td>
                      </ng-container>

                      <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef>Total</th>
                        <td mat-cell *matCellDef="let element">{{element?.totalItems}}</td>
                      </ng-container>

                      <ng-container matColumnDef="category">
                        <th mat-header-cell *matHeaderCellDef>Category</th>
                        <td mat-cell *matCellDef="let element">{{element.categoryId?.name || "NA"}}</td>
                      </ng-container>

                      <ng-container matColumnDef="company">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let element">{{element.companyId?.name || "NA"}}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="recentSamplesDisplayedColumns" class="t_head"></tr>
                      <tr mat-row *matRowDef="let row; columns: recentSamplesDisplayedColumns;"></tr>
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="recentSamplesDisplayedColumns.length">
                          No data available
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
        </div>
      </div>
      }

      <!-- Company Dashboard (userType == 3) -->
      @else if (userType==3) {
      <div class="row">

        <!-- Dashboard Header with Date Range Filter -->
        <div class="row align-items-center mb-3 gx-2">
          <div class="col-9 col-md-6">
            <h5 class="mb-0 text-dark fw-bold">Dashboard</h5>
          </div>
          <div class="col-3 col-md-6 d-flex justify-content-end">
            <div class="col-lg-6">
              <mat-form-field class="w-100" (click)="picker.open()">
                <mat-label>Filter By Date Range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate placeholder="Start" [(ngModel)]="startdate" readonly />
                  <input matEndDate placeholder="End" [(ngModel)]="enddate" (dateChange)="companyDashboard($event)" readonly />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                @if (startdate || enddate) {
                <mat-icon matSuffix (click)="clearDateRange()" class="clear-icon fs-7" style="cursor: pointer;">close</mat-icon>
                }
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Total Samples Added Card -->
        <div class="col-md-6 col-xl-3">
          <app-card [hidHeader]="true" routerLink="/sample" style="cursor: pointer;">
            <h6 class="mb-4">Total Samples Added</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-package f-30 m-r-10" style="color: #003E53;"></i>
                  {{companyDashboardData?.totalSampleAdded || 0}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Today Samples Added Card -->
        <div class="col-md-6 col-xl-3">
          <app-card [hidHeader]="true" routerLink="/sample" [queryParams]="{ isTodaySample: true }"style="cursor: pointer;">
            <h6 class="mb-4">Today Samples Added</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-calendar f-30 m-r-10" style="color: #003E53;"></i>
                  {{companyDashboardData?.todaySampleAdded??0}}
                </h3>
              </div>
            </div>
          </app-card>
        </div>

        <!-- Total Categories Card -->


        <!-- Sample Inventory Card -->
        <div class="col-md-6 col-xl-3">
          <app-card [hidHeader]="true" routerLink="/sample" style="cursor: pointer;">
            <h6 class="mb-4">Sample inventory</h6>
            <div class="row d-flex align-items-center">
              <div class="col-9">
                <h3 class="f-w-300 d-flex align-items-center m-b-0">
                  <i class="feather icon-box f-30 m-r-10" style="color: #003E53;"></i>
                  <!-- @if (companyDashboardData?.sampleInventory?.length > 0) {
                  {{ companyDashboardData.sampleInventory[0]?.InventoryStock??0 }}
                  }
                  @else {
                  <span>0</span>
                  } -->
                   {{ companyDashboardData?.sampleInventory[0]?.InventoryStock??0 }}
                </h3>
              </div>
            </div>
          </app-card>
        </div>
         <div class="col-md-6 col-xl-3">
          <app-card [hidHeader]="true" routerLink="/customer/samples/report" style="cursor: pointer;">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center">
                <i class="feather icon-clipboard f-30 m-r-10" style="color: #003E53;"></i>
                <strong>Issued Total</strong>
              </div>
              <h5 class="mb-0">
                 <!-- @if (companyDashboardData?.issuedTotal?.length > 0) {
                {{ companyDashboardData.issuedTotal[0]?.totalIssuedCUS || 0 }}
                }
                @else {
                0
                } -->

                {{ companyDashboardData?.issuedTotal[0]?.totalIssuedCUS??0 }}
              </h5>
            </div>

            <div class="d-flex justify-content-between">
              <span class="text-muted">Issued Today</span>
              <span class="text-muted">:
                <!-- @if(!!companyDashboardData?.issuedTodayCus) {
                {{ companyDashboardData?.issuedTodayCus[0]?.totalIssued??0}}
                }
                @else {
                0
                } -->
                {{ companyDashboardData?.issuedTodayCus[0]?.totalIssued??0}}
              </span>
            </div>
          </app-card>
        </div>

        <!-- Wholesalers Card -->
        <div class="col-md-6 col-xl-6">
          <app-card [hidHeader]="true" routerLink="/wholesalers" style="cursor: pointer;">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center">
                <i class="feather icon-briefcase f-30 m-r-10" style="color: #003E53;"></i>
                <strong>Wholesalers</strong>
              </div>
              <h5 class="mb-0">{{ companyDashboardData?.totalWHL }}</h5>
            </div>
            <div class="d-flex justify-content-between mb-1">
              <span class="text-muted">Issued Total</span>
              <span class="text-muted">:
                <!-- @if (companyDashboardData?.issuedTotal?.length > 0 && companyDashboardData.issuedTotal[0]?.totalIssuedWHL) {
                {{ companyDashboardData.issuedTotal[0].totalIssuedWHL }}
                }
                @else {
                0
                } -->
                {{ companyDashboardData?.issuedTotal[0]?.totalIssuedWHL??0 }}
              </span>
            </div>
            <div class="d-flex justify-content-between">
              <span class="text-muted">Issued Today</span>
              <span class="text-muted">:
                <!-- @if (companyDashboardData?.issuedTodayDis?.length > 0 && companyDashboardData.issuedTodayDis[0]?.totalIssuedToWHL) {
                {{ companyDashboardData.issuedTodayDis[0].totalIssuedToWHL }}
                }
                @else {
                0
                } -->
                {{ issuedTodayToWHL??0 }}

              </span>
            </div>
          </app-card>
        </div>

        <!-- Retailers Card -->
        <div class="col-md-6 col-xl-6">
          <app-card [hidHeader]="true" routerLink="/retailers" style="cursor: pointer;">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center">
                <i class="feather icon-shopping-cart f-30 m-r-10" style="color: #003E53;"></i>
                <strong>Retailers</strong>
              </div>
              <h5 class="mb-0">{{ companyDashboardData?.totalRTL??0 }}</h5>
            </div>
            <div class="d-flex justify-content-between mb-1">
              <span class="text-muted">Issued Total</span>
              <span class="text-muted">:
                <!-- @if (companyDashboardData?.issuedTotal?.length > 0) {
                {{ companyDashboardData.issuedTotal[0]?.totalIssuedRTL || 0 }}
                }
                @else {
                0
                } -->
                {{ companyDashboardData?.issuedTotal[0]?.totalIssuedRTL??0 }}
              </span>
            </div>
            <div class="d-flex justify-content-between">
              <span class="text-muted">Issued Today</span>
              <span class="text-muted">:
                <!-- @if (companyDashboardData?.issuedTodayDis?.length > 0) {
                {{ companyDashboardData.issuedTodayDis[0]?.totalIssuedToRTL || 0 }}
                }
                @else {
                0
                } -->
                 <!-- {{ companyDashboardData?.issuedTodayDis[0]?.totalIssuedToRTL??0 }} -->
                   {{issuedTodayToRTL??0}}
              </span>
            </div>
          </app-card>
        </div>

        <!-- Customers Card -->


        <!-- Sample Inventory Table -->
        <div class="col-xl-12 col-md-12">
          <app-card cardTitle="Recent Users" cardClass="Recent-Users table-card" blockClass="p-0">
            <div class="table-responsive">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Sample Distribution</h5>
                  <button class="btn btn-sm btn-primary" routerLink="/distributors/samples/report">View All</button>
                </div>

                <div class="table-responsive">
                  <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered compact-table">

                      <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                        <td mat-cell *matCellDef="let row; let index = index">{{index+1}}</td>
                      </ng-container>

                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Sample Name</th>
                        <td mat-cell *matCellDef="let element">{{element?.name}}</td>
                      </ng-container>

                      <ng-container matColumnDef="barcode">
                        <th mat-header-cell *matHeaderCellDef>Bar Code</th>
                        <td mat-cell *matCellDef="let element">{{element?.sampleCode}}</td>
                      </ng-container>

                      <ng-container matColumnDef="whlLimit">
                        <th mat-header-cell *matHeaderCellDef class="text-center">WHL Limit</th>
                        <td mat-cell *matCellDef="let element">{{element?.maxIssueQuantityWholesaler}}</td>
                      </ng-container>

                      <ng-container matColumnDef="rtlLimit">
                        <th mat-header-cell *matHeaderCellDef class="text-center">RTL Limit</th>
                        <td mat-cell *matCellDef="let element">{{element?.maxIssueQuantityRetailer}}</td>
                      </ng-container>

                      <ng-container matColumnDef="cusLimit">
                        <th mat-header-cell *matHeaderCellDef class="text-center">CUS Limit</th>
                        <td mat-cell *matCellDef="let element">{{element?.maxIssueQuantityCustomer}}</td>
                      </ng-container>

                      <ng-container matColumnDef="whlIssued">
                        <th mat-header-cell *matHeaderCellDef class="text-center">WHL Issued</th>
                        <td mat-cell *matCellDef="let element">{{element?.issuedToWHL}}</td>
                      </ng-container>

                      <ng-container matColumnDef="rtlIssued">
                        <th mat-header-cell *matHeaderCellDef class="text-center">RTL Issued</th>
                        <td mat-cell *matCellDef="let element">{{element?.issuedToRTL}}</td>
                      </ng-container>

                      <ng-container matColumnDef="cusIssued">
                        <th mat-header-cell *matHeaderCellDef class="text-center">CUS Issued</th>
                        <td mat-cell *matCellDef="let element">{{element?.issuedToCustomer}}</td>
                      </ng-container>

                      <ng-container matColumnDef="whlHold">
                        <th mat-header-cell *matHeaderCellDef class="text-center">WHL Hold</th>
                        <td mat-cell *matCellDef="let element">{{element?.holdToWHL}}</td>
                      </ng-container>

                      <ng-container matColumnDef="rtlHold">
                        <th mat-header-cell *matHeaderCellDef class="text-center">RTL Hold</th>
                        <td mat-cell *matCellDef="let element">{{element?.holdToRTL}}</td>
                      </ng-container>

                      <ng-container matColumnDef="totalItems">
                        <th mat-header-cell *matHeaderCellDef>Total</th>
                        <td mat-cell *matCellDef="let element">{{element?.totalItems}}</td>
                      </ng-container>

                      <ng-container matColumnDef="assignedItems">
                        <th mat-header-cell *matHeaderCellDef>Distributed</th>
                        <td mat-cell *matCellDef="let element">{{element?.assignedItems}}</td>
                      </ng-container>

                      <ng-container matColumnDef="stock">
                        <th mat-header-cell *matHeaderCellDef>Remaining</th>
                        <td mat-cell *matCellDef="let element">{{element?.leftItems}}</td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                          No data available
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
        </div>
      </div>
      }
    </app-card>
  </div>
</div>
